export default () => window.location.hostname.includes('local');
